import { Fieldset } from '@headlessui/react';
import { PlusCircleIcon } from '@heroicons/react/20/solid';
import CT from '@marketplace-ai/tags';
import { FieldValues, useFormContext } from 'react-hook-form';

interface AddFacilityButtonProps<TFormValues extends FieldValues> {
  className?: string;
  handleFacilityOpen: (values: TFormValues) => void;
}

export const AddFacilityButton = <TFormValues extends FieldValues>(
  props: AddFacilityButtonProps<TFormValues>
) => {
  const { className, handleFacilityOpen } = props;
  const { getValues } = useFormContext<TFormValues>();
  const fieldsetClassName = ['flex pr-1', className].filter(Boolean).join(' ');

  return (
    <Fieldset className={fieldsetClassName}>
      <button
        className="flex items-center gap-2 hover:cursor-pointer"
        data-cy={CT.facility.form.addBtn}
        type="button"
        onClick={() => handleFacilityOpen(getValues())}
      >
        <PlusCircleIcon aria-hidden="true" className="size-6 text-primary-50" />
        <p className="body-text-sb">Add a Facility</p>
      </button>
    </Fieldset>
  );
};
